import { stack } from '@bts-web/utils-style-engine';

export const wrapperStyles = stack({
  height: '100%',
  gap: 0,
});

export const bodyStyles = stack({
  flex: '1',
  p: 'medium',
  gap: 0,
});

export const contentStyles = stack({
  direction: 'column',
  flex: '1',
  overflow: 'auto',
  gap: 'medium',
});

export const bottomSectionStyles = stack({
  direction: 'column',
  gap: 'small',
  pt: 'small',
});
